import { Component } from '@angular/core';
import { UserStore } from '../../data-access/stores/user.store';
import { Roles } from '../../../authentication/data-access/models/auth.model';
import { UniversityStudentDetails } from '../../../university-dashboard/data-access/models/student-details-model';
import { URLS } from '../../../student/enums/legalRoutes';
import { Observable } from 'rxjs';
import { map, switchMap, filter, shareReplay } from 'rxjs/operators';
import { StudentService } from '../../../student/services/student.service';
import { shouldShowFundDistribution as canShowFundDistribution } from '../../utils/functions/checkFundDistribution.function';
@Component({
    selector: 'app-bursary-information',
    templateUrl: './bursary-information.component.html',
    styleUrls: ['./bursary-information.component.scss', '../../../university-dashboard/ui/student-details/student-details.component.scss', '../../utils/styling/sharedStudentDetails.scss'],
    standalone: false
})
export class BursaryInformationComponent {
  isStudent: boolean = false;
  rolesEnum: typeof Roles = Roles;
  invoiceStatus$: Observable<string>;
  urls: typeof URLS = URLS;
  student$: Observable<UniversityStudentDetails>;

  constructor(
    private userStore: UserStore,
    private studentService: StudentService
  ) {
    this.isStudent = this.userStore.hasRole([this.rolesEnum.STUDENT]);
    this.student$ = this.userStore.get().pipe(
      switchMap(user => this.studentService.getStudentApplicationGuid(user.email)),
      map(response => response.results),
      filter((student): student is UniversityStudentDetails => !!student),
      shareReplay(1) 
    );
    this.invoiceStatus$ = this.student$.pipe(
      map(student => this.setStatus(student.invoiceStatus))
    );
    }
    
  setStatus(status: string) {
    switch (status) {
      case 'Pending':
        return 'Pending invoice';
      case 'Approved':
        return 'Bursary Active';
      case 'In Review':
        return 'Pending payment';
      default:
        return '';
    }
  }
  getGreyTextClass() {
    return {
      'white-small-text': this.isStudent,
      'grey-text': !this.isStudent,
    };
  }
  getBlackTextClass() {
    return this.isStudent ? 'white-text' : 'black-text';
  }
  getContainerClass() {
    return {
      'student-bursaries-info-container row2': this.isStudent,
      'student-info-more row2': !this.isStudent,
    };
  }

  shouldShowFundDistribution(student: UniversityStudentDetails): boolean {
    return canShowFundDistribution(student);
  }
}
